var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowIntlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03516 0.785156C6.28125 0.539062 6.69141 0.539062 6.9375 0.785156L12.2148 6.03516C12.4609 6.30859 12.4609 6.71875 12.2148 6.96484C11.9414 7.23828 11.5312 7.23828 11.2852 6.96484L6.5 2.17969L1.71484 6.96484C1.44141 7.23828 1.03125 7.23828 0.785156 6.96484C0.511719 6.71875 0.511719 6.30859 0.785156 6.0625L6.03516 0.785156Z",
    fill: "#008577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowIntlLogo);
export default __webpack_public_path__ + "static/media/upArrowIntlLogo.e77ef1c42c905768016a31487db5ade1.svg";
export { ForwardRef as ReactComponent };